//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { datetimeFormat } from '@/plugin/format.js'
export default {
  data () {
    var checkPassword = (rule, value, callback) => {
      const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/ // 校验密码6-18位
      if (!value) {
        return callback(new Error('请设置密码'))
      }
      setTimeout(() => {
        if (passwordReg.test(value)) {
          callback()
        } else {
          callback(new Error('密码须包含数字、字母两种元素，且密码位数为6-16位'))
        }
      }, 100)
    }
    return {
      adminusersdata: [],
      filters: {
        username: ''
      },
      editDialogVisible: false, // 新增编辑界面是否显示
      dataForm: {
        username: '',
        password: '',
        issuperamdin: false
      },
      dataFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { validator: checkPassword, trigger: 'blur' }]
      },
      selections: [],
      lockList: [],
      unLockList: []
    }
  },
  methods: {
    getlist: function () {
      let params = {
        UserName: this.filters.username
      }
      this.$api
        .getAdminUser(params)
        .then(res => {
          if (res.Status === 1) {
            this.adminusersdata = res.Entity
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function (res) {
          alert(res)
        })
    },
    handleAdd: function () {
      this.editDialogVisible = true
    },
    handleLock: function () {
      this.$confirm(
        '锁定' + this.lockList.length.toString() + '个用户吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        var params = []
        this.lockList.forEach(item => {
          params.push(item.Id)
        })
        this.$api.lockAdminUser(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '用户锁定成功',
              type: 'success'
            })
            this.getlist()
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleUnLock: function () {
      this.$confirm(
        '激活' + this.unLockList.length.toString() + '个用户吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        var params = []
        this.unLockList.forEach(item => {
          params.push(item.Id)
        })
        this.$api.unLockAdminUser(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '用户激活成功',
              type: 'success'
            })
            this.getlist()
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleDelete: function () {
      this.$confirm(
        '删除' + this.selections.length.toString() + '个用户吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        var params = []
        this.selections.forEach(item => {
          params.push(item.Id)
        })
        this.$api.deleteAdminUser(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '用户删除成功',
              type: 'success'
            })
            this.getlist()
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    editSubmit: function () {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {
            cancelButtonClass: 'btn-custom-cancel'
          }).then(() => {
            let params = {
              UserName: this.dataForm.username,
              Password: this.dataForm.password,
              IsSuperAdmin: this.dataForm.issuperadmin
            }
            this.$api.addAdminUser(params).then(res => {
              if (res.Status === 1) {
                this.$message({ message: '提交成功', type: 'success' })
                this.editDialogVisible = false
                this.getlist()
              } else {
                this.$alert(res.Message, '错误', {
                  confirmButtonText: '确定'
                })
              }
            })
          })
        }
      })
    },
    selectionChange: function (selections) {
      this.selections = selections
      this.lockList = []
      this.unLockList = []
      selections.forEach(item => {
        if (item.Status === 0) {
          this.lockList.push(item)
        } else {
          this.unLockList.push(item)
        }
      })
    },
    formatState: function (row, column) {
      if (row.Status === 1) {
        return '已停用'
      } else {
        return '使用中'
      }
    },
    formatIsSuperAdmin: function (row, column) {
      return row.IsSuperAdmin === true ? '是' : ''
    },
    datetimeFormat: function (row, column) {
      let time = datetimeFormat(row, column)
      return time
    }
  },
  mounted () {
    this.getlist()
  }
}



// WEBPACK FOOTER //
// ./src/admin/AdminUser.vue